import { useEffect, useRef } from "react";

export function useScrollRestorationById({
  isMounted,
  items,
  hasMore,
  isLoading,
  loadMore,
}) {
  const restoredRef = useRef(false);

  useEffect(() => {
    if (restoredRef.current) return;
    if (isMounted !== null && isMounted !== true) return;

    const itemIdToScrollTo = sessionStorage.getItem("scrollId");

    if (!itemIdToScrollTo) {
      restoredRef.current = true;
      return;
    }

    const itemElement = document.getElementById(itemIdToScrollTo);

    // TARGET DOM'DA → RESTORE
    if (itemElement) {
      restoredRef.current = true;

      requestAnimationFrame(() => {
        itemElement.scrollIntoView({
          behavior: "auto",
          block: "start",
        });
      });

      return;
    }

    // TARGET HENÜZ DOM'DA DEĞİL → SONRAKİ SAYFAYI GETİR
    if (hasMore && !isLoading) {
      loadMore();
      return;
    }

    // TÜM SAYFALAR YÜKLENDİ AMA TARGET YOK
    if (!hasMore) {
      restoredRef.current = true;
    }
  }, [isMounted, items, hasMore, isLoading, loadMore]);
}
